import React, { useRef } from 'react';
import { useIntersectionObserver } from 'usehooks-ts';
import RecentlyViewedProducts from '@components/product/recently-viewed-products/recently-viewed-products';

const RecentlyViewedProductsWrapper: React.FC = () => {
  const recentlyViewedProductsBlockRef = useRef(null);

  const shouldRenderRecentlyViewedProductsBlock =
    useIntersectionObserver(recentlyViewedProductsBlockRef, {
      freezeOnceVisible: true,
      threshold: 0.5,
    })?.isIntersecting || false;

  return (
    <div ref={recentlyViewedProductsBlockRef}>
      {shouldRenderRecentlyViewedProductsBlock && <RecentlyViewedProducts />}
    </div>
  );
};

export default RecentlyViewedProductsWrapper;
